//@flow
import { stringsRepo } from "./StringsRepository";
export { stringsRepo };